import React, { useMemo } from 'react';
import useMobileLayout from 'Hooks/useMobileLayout';
import { FDStack } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import _ from 'lodash';
import { ExploreItem } from './ExploreItem';

const ITEMS_PER_CHUNK = 2;

export const ExploreItems = ({ collection }) => {
  const isMobile = useMobileLayout();

  const result = useMemo(() => _.chunk(collection.resources().list(), ITEMS_PER_CHUNK), [collection]);

  if (!collection) {
    return null;
  }

  return (
    <FDStack direction={'column'} spacing={3} alignItems={'stretch'}>
      {result.map((r, i) => {
        return (
          <FDStack
            // eslint-disable-next-line react/no-array-index-key -- we have nothing better to use here other than the array index
            key={i}
            direction={isMobile ? 'column' : 'row'}
            spacing={3}
            justifyContent={'center'}
            alignItems={'stretch'}
          >
            {r.map((ei) => <ExploreItem key={ei.id()} resource={ei} />)}
          </FDStack>
        );
      })}
    </FDStack>
  );
};

ExploreItems.propTypes = {
  collection: PropTypes.instanceOf(fr.Collection).isRequired,
};
